import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { IPatientInfo } from '../ipatient-info';
import { PatientAppointmentHistoryComponent } from "../../appointment/patient-appointment-history/patient-appointment-history.component";
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { AddressDetailsComponent } from "./address-details/address-details.component";

@Component({
  selector: 'app-patient-view',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    PatientAppointmentHistoryComponent,
    PersonalDetailsComponent,
    AddressDetailsComponent
  ],
  templateUrl: './patient-view.component.html',
  styleUrl: './patient-view.component.scss'
})
export class PatientViewComponent implements OnInit {
  patientDetails: IPatientInfo | undefined;
  appointmentHistoryFlag: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: { patient?: IPatientInfo },
  ) { }

  ngOnInit(): void {
    this.patientDetails = this._data.patient;
  }

  onHistoryLength(length: number) {
    this.appointmentHistoryFlag = length > 0;
  }

  get hasAddressOrContact(): boolean {
    const addressHasData = this.patientDetails?.address?.some(addr =>
      addr.address1 || addr.address2 || addr.area || addr.country || addr.district || addr.state || addr.pincode || addr.taluka
    );

    const contactHasData = this.patientDetails?.contactInfo?.some(contact =>
      contact.contact || contact.phone || contact.email
    );

    return !!(addressHasData || contactHasData);
  }

}
